//Normally, variables in a function reset every render. useState keeps its value between renders and re-renders the component when the value changes.
import React, { useState } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import SignUp from './Pages/SignUp';
import LogIn from './Pages/LogIn';
import Leaderboard from './Pages/Leaderboard'; //Start here
import GameRoom from './Pages/GameRoom';
import HomePage from './Pages/Home';
import Lobby1 from './Pages/Lobby1';
import Profile from './Pages/Profile';
import Help from './Pages/Help';
import Landing from './Pages/Landing';
import ResetPassword from './Pages/ResetPassword';
import NotFound from "./Pages/NotFound";
import OldHomepage from "./Pages/OldHomepage";



function App() {

    const [isAuthenticated, setIsAuthenticated] = useState(!!localStorage.getItem('authToken')); //!! coerces truthy/falsy to a boolean.

    const handleLogin = () => {
        setIsAuthenticated(true);
    };

    const handleLogout = () => {
        localStorage.removeItem('authToken');
        setIsAuthenticated(false);
    };

    // (Optional) keep tabs in sync: if token is cleared in another tab, log out here too
    React.useEffect(() => {
        const onStorage = (e) => {
        if (e.key === 'authToken' && !e.newValue) setIsAuthenticated(false);
        };
        window.addEventListener('storage', onStorage);
        return () => window.removeEventListener('storage', onStorage);
    }, []);
    
    return (
        <Router>
            <Routes>
                <Route path="/" element={<Landing />} />
                <Route path="/reset-password" element={<ResetPassword />} />
                <Route path="/signup" element={<SignUp onLogin={handleLogin} />} />
                <Route path="/leaderboard" element={<Leaderboard />} />
                <Route path="*" element={<NotFound />} />
                <Route path="/how-to-play" element={<Help />} />
                <Route path="/game/:roomId" element={<GameRoom />} /> 

                {/*Protected Routes */}
                
                <Route
                    path="/login"
                    element={isAuthenticated ? <Navigate to="/home" /> : <LogIn onLogin={handleLogin} />}
                />

                <Route
                    path="/home"
                    element={isAuthenticated ? <HomePage onLogout={handleLogout} /> : <Navigate to="/login" />}
                />

                <Route path="/lobby1" element={isAuthenticated ? <Lobby1 /> : <Navigate to="/login" />} />
                <Route path="/profile" element={isAuthenticated ? <Profile /> : <Navigate to="/login" />} />
                <Route path="/game/:roomId" element={isAuthenticated ? <GameRoom /> : <Navigate to="/login" />} />

                <Route path="/old-homepage" element={<OldHomepage />} />

                
            </Routes>
        </Router>

        
    );
}

export default App;
